export const locale = {
    lang: 'zh1',
    data: {
      'NOMBREIDIOMAS': {
        'es': '西班牙文',
        'en': '英語',
        'pt': '葡萄牙語',
        'zh1': '繁體中文',
        'zh2': '簡體中文',
        'tr': '土耳其語',
        'vi': '越南語',
        'ja': '日本',
        'my': '馬來語',
        'ro': '羅馬尼亞語',
        'ru': '俄語',
        'fr': '法文',
        'de': '德語',
        'it': '義大利文',
        'nl': '荷蘭語',
        'ms': '馬來語',
        'hi': '印地語',
        'id': '印度尼西亞',
        'ua': '烏克蘭',
        'ge': '格魯吉亞語',
        'uz': '烏茲別克語',
        'az': '阿塞拜疆人',
        'kk': '哈薩克斯坦',
        'hr': '克羅地亞語',
        'ar': '阿拉伯',
        'mk': '馬其頓語',
        'lv': '拉脫維亞語',
        'pr': '葡萄牙語（葡萄牙）',
        'th': '泰國',
      }
    }
};
